<template>
  <div class="form-field form-field-radio form-field-radio-extended">
    <label>Campaign Privacy</label>
    <div class="radio-option">
      <input v-model="item.privacy" type="radio" value="invite" :disabled="item.privacy == 'public' && item.reward_type=='voucher'">
      <div class="radio-label">
        <h5>Private Campaign</h5>
        <p>For private campaigns recipient always must be invited to the campaign first before claiming a gift.<span v-if="mode=='create'"> You can pick the gift for recipient yourself, sent them an invite email or generate an unique invite link for a recipient to claim their gift.</span></p>
        <div id="form-field-auto_approve" class="form-field" style="margin-top: 10px; width: 100%" v-if="item.privacy=='invite'">
            <input v-model="item.auto_approve" type="checkbox" id="form-input-approve" :disabled="['voucher','mixed'].includes(item.reward_type)">
            <span class="checkbox-label">Auto-approve gift registrations</span>
        </div>
        <div id="form-field-auto_approve" class="form-field" style="width: 100%" v-if="item.privacy=='invite'">
            <input v-model="item.page_restricted" type="checkbox" id="form-input-approve" :disabled="['voucher','mixed'].includes(item.reward_type)">
            <span class="checkbox-label">Restrict access to gift registration page only to invitees</span>
        </div>
        
        <div class="small-note" style="margin-left: 0; margin-top: 5px" v-if="item.privacy != 'public' && item.reward_type!='physical'"><b>Voucher</b> and <b>mixed</b> campaigns are always private. <br>Their gift registration page is only accessible by invitation.</div>
        <div class="small-note" style="margin-left: 0; margin-top: 5px" v-else-if="item.privacy != 'public' && ['sales','reviews'].includes(item.type)">Campaigns of this type are always private.</div>
        <div class="small-note" style="margin-left: 0; margin-top: 5px" v-else-if="item.privacy == 'public' && item.reward_type=='voucher'">Your <i>Account Manager</i> has overriden privacy settings of this campaign. Contact them to change the privacy.</div>

      </div>
    </div>
    
    <div class="radio-option" v-if="item.privacy == 'public' || (item.reward_type=='physical' && !['sales','reviews'].includes(item.type))">
      <input v-model="item.privacy" type="radio" value="public">
      <div class="radio-label">
        <h5>Open Campaign</h5>
        <p v-if="mode=='create'">In addition to all tools available for private campaign, anyone will be able to claim a gift on your campaign public gift registration page. You will need to approve any public registrations to get them processed.</p>
        <p v-else>Anyone can register for a gift at your public gift registration page.</p>
      </div>
      
      <div class="form-line" v-if="item.privacy=='public'" style="margin-left: 12px;">
          <div class="form-field" style="width: 100%">
              <label>Disabled Email Domains</label>
              <input v-model="item.disabled_domains" type="text" id="form-input-name" required="required" maxlength="180" />
              <div class="small-note" style="margin-top: 10px">For an open campaign, you can specify email domains that you won't accept. When entering multiple domains separate each with a space.</div>
          </div>
      </div>     
    </div>   
    
                  
  </div>
</template>


<script>
export default {
    name: "FieldPrivacy",
    props: [ 'item', 'mode' ],
    watch: {
		'item.reward_type': {
			handler (newVal, oldVal) {
				if (['voucher','mixed'].includes(newVal) && oldVal !== newVal) {
                    this.item.auto_approve = true;
                    this.item.page_restricted = true;
                }
			},
			deep: true,
		}
	}
}
</script>